import type { OrderPaymentStatus } from "../Account/API/handlePaymentAPI";

/**
 * 「這筆訂單尚未開放線上付款」畫面的說明文字（LINE 模式與一次性付款連結共用）。
 * 線上付款在配送員請款之後開放（2026-10-19 起不看平台狀態是不是配送中：網頁版 DAPP 的
 * 配送員不按接單，平台會一直是待接單），訂單完成或取消後關閉。
 */
export function notPayableHint(
  status: Pick<OrderPaymentStatus, "order_status" | "payment_status" | "payment_requested_at"> | null
): string {
  const st = status?.order_status;
  if (status?.payment_status === "cash_fallback") return "配送員已改為現金收款，請以現金支付給配送員。";
  if (st === "canceled") return "訂單已取消，無需付款。";
  if (st === "completed") return "訂單已完成結案；若對款項有疑問請聯絡瓦斯行。";
  // 請過款、現在又回到未請款：配送員取消了，或打開付款頁 5 分鐘內沒付自動取消——手上的連結已失效
  if (status?.payment_status === "none" && status?.payment_requested_at)
    return "這次的付款連結已失效（配送員取消請款，或打開付款頁超過 5 分鐘沒有付款），請聯絡配送員重新請款。";
  if (status?.payment_status === "none") return "配送員送達確認金額後會通知你付款，請稍候。";
  return "若已現場付款，無需再付款；有疑問請聯絡瓦斯行。";
}
